import GlobalLoadingIndicator from './GlobalLoadingIndicator';

export default GlobalLoadingIndicator;
